import api from "../core/axios";

export const complaintsAPI = {
  getAll: (params) => api.get("/complaints", { params }),
  getById: (id) => api.get(`/complaints/${id}`),
  create: (data) => api.post("/complaints", data),
  update: (id, data) => api.post(`/complaints/${id}`, data),
  delete: (id) => api.delete(`/complaints/${id}`),
  assign: (id, data) => api.post(`/complaints/${id}/assign`, data),
  resolve: (id, data) => api.post(`/complaints/${id}/resolve`, data),
  getStatistics: () => api.get("/complaints/statistics"),
  complaintActivities:  (categoryId) => api.get(`/complaints/${categoryId}/audit-logs`),

  searchAssigned: (params) => api.get('/complaints/search-users',  { params }),
  searchComplainantResident: (params) => api.get("/complaints/search-resident", { params }),
  getCategory: (params) => api.get("/complaints/categories", { params }),
  createCategory: (data) => api.post('/complaints/categories', data),
  deleteCategory: (categoryId) => api.delete(`/complaints/categories/${categoryId}`),
  updateCategory: (categoryId, data) => api.put(`/complaints/categories/${categoryId}`, data),

  selectCategory: () => api.get("/complaints/select-complaint-categories"),
  // export: (params) => api.get('/complaints/statistics/export',  { params }),
  export: (params) =>
  api.get('/complaints/statistics/export', {
    params,
    responseType: "blob",
  }),
};
